<footer class="app-footer">
  <div class="app-footer__inner">
    <div class="app-footer__legal">
      <button mat-button class="app-footer__link" (click)="openLegal('privacy')">Privacy Policy</button>
      <span class="app-footer__divider" aria-hidden="true">|</span>
      <button mat-button class="app-footer__link" (click)="openLegal('terms')">Terms &amp; Conditions</button>
    </div>

    <div class="app-footer__phone">
      <a href="tel:+27861900301" class="app-footer__phone-link">
        <app-icon name="phone" [size]="20" />
        0861 900 301
      </a>
    </div>

    <div class="app-footer__brand">
      <a
        class="app-footer__brand-link"
        href="https://www.capx.co.za"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="CapX"
      >
        <img class="app-footer__logo app-footer__logo--light" src="assets/images/logo.png" alt="CapX Flow" />
        <img class="app-footer__logo app-footer__logo--dark" src="assets/images/logo-dark.png" alt="CapX Flow" />
      </a>
      <span class="app-footer__attribution" aria-hidden="true">|</span>
      <a
        class="app-footer__attribution-link"
        href="https://www.capx.co.za"
        target="_blank"
        rel="noopener noreferrer"
      >
        <p class="app-footer__attribution-text">
          Powered by<br />CapX Business Finance
        </p>
      </a>
    </div>
  </div>
</footer>
